import { render, staticRenderFns } from "./adjust.vue?vue&type=template&id=ecdd704e&scoped=true"
import script from "./adjust.vue?vue&type=script&lang=js"
export * from "./adjust.vue?vue&type=script&lang=js"
import style0 from "./adjust.vue?vue&type=style&index=0&id=ecdd704e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecdd704e",
  null
  
)

export default component.exports